import React from 'react';
import {
  CombinatorSelectorProps,
  FullCombinator,
  OptionGroup,
} from 'react-querybuilder';

import {Box, Chip, Typography} from '@mui/material';
import AurIcon, {IconNames} from '../aur-icon/AurIcon';

// Type guard to check if an option is a FullCombinator
const isFullCombinator = (
  option: FullCombinator<string> | OptionGroup<FullCombinator<string>>
): option is FullCombinator<string> => {
  return (option as FullCombinator<string>).name !== undefined;
};

const AurCustomCombinatorSelector: React.FC<CombinatorSelectorProps> = ({
  options,
  value,
  handleOnChange,
}) => {
  // Extract the list of combinators (filter out OptionGroups if present)
  const flatOptions = options
    .map(
      (option: FullCombinator<string>) =>
        isFullCombinator(option)
          ? option
          : (option as FullCombinator<string>).options // Flatten grouped options
    )
    .flat() as FullCombinator<string>[];

  // Handle chip click to cycle through the options
  const handleChipClick = () => {
    const currentIndex = flatOptions.findIndex((opt) => opt.name === value);
    const nextIndex = (currentIndex + 1) % flatOptions.length; // Cycle to the next option
    handleOnChange(flatOptions[nextIndex].name); // Update combinator value
  };

  return (
    <Chip
      className="aur-custom-combinator-selector"
      data-testid="custom-combinator-test-id"
      color="primary"
      label={
        <>
          <Box className={'replace-icon-container'}>
            <AurIcon
              icon={IconNames.ReplaceIcon}
              customClassName="replace-icon"
            />
          </Box>
          <Typography className="typo-text label2_size">
            {value?.toUpperCase()}
          </Typography>
        </>
      }
      onClick={handleChipClick}
    />
  );
};

export default AurCustomCombinatorSelector;
